import { AccordionModule } from 'primeng/accordion';
import { ButtonComponent } from './button/button.component';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CurrencyInputComponent } from '../../components/currency-input/currency-input.component';
import { CurrencyPipe } from './pipes/currency.pipe';
import { DatePipe } from './pipes/date.pipe';
import { DialogComponent } from './dialog/dialog.component';
import { DialogModule } from 'primeng/dialog';
import { DropdownInputComponent } from './dropdown-input/dropdown-input.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormHeaderComponent } from './form-header/form-header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfoboxAsideComponent } from './infobox-aside/infobox-aside.component';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LinesSeparatorComponent } from './lines-separator/lines-separator.component';
import { LockOpenIconComponent } from './lock-open-icon/lock-open-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { NumberPipe } from './pipes/number.pipe';
import { SmartDecimalPipe } from './pipes/smart-decimal.pipe';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ScrollIntoViewDirective } from '../../shared/directives/scroll-into-view.directive';
import { SkeletonModule } from 'primeng/skeleton';
import { SwiperModule } from 'swiper/angular';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { ValidationMessageComponent } from './validation-message/validation-message.component';

@NgModule({
  declarations: [
    ButtonComponent,
    CurrencyInputComponent,
    CurrencyPipe,
    DatePipe,
    DialogComponent,
    DropdownInputComponent,
    FormHeaderComponent,
    InfoboxAsideComponent,
    LinesSeparatorComponent,
    LockOpenIconComponent,
    NumberPipe,
    SmartDecimalPipe,
    ProgressBarComponent,
    ScrollIntoViewDirective,
    TooltipComponent,
    ValidationMessageComponent,
  ],
  imports: [
    AccordionModule,
    CommonModule,
    ConfirmDialogModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    MatTooltipModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    SkeletonModule,
    SwiperModule,
    TabViewModule,
    ToastModule,
    TooltipModule,
    TranslocoModule,
  ],
  exports: [
    AccordionModule,
    ButtonComponent,
    ConfirmDialogModule,
    CurrencyInputComponent,
    CurrencyPipe,
    DatePipe,
    DropdownInputComponent,
    DropdownModule,
    FormHeaderComponent,
    FormsModule,
    InfoboxAsideComponent,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    LinesSeparatorComponent,
    LockOpenIconComponent,
    MatTooltipModule,
    NumberPipe,
    SmartDecimalPipe,
    OverlayPanelModule,
    ProgressBarComponent,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    ScrollIntoViewDirective,
    SkeletonModule,
    SwiperModule,
    TabViewModule,
    ToastModule,
    TooltipComponent,
    TooltipModule,
    TranslocoModule,
    ValidationMessageComponent,
  ],
  providers: [ConfirmationService, MessageService],
})
export class SharedModule {}
